import { CurrencyPipe } from "@angular/common";
import { BasketSummary, CurrentTransactionDetails, Customer, DELIVERY_METHODS, ItemDiscounts, TaxBreakdown, TaxLine, TBasket, TotalTaxSummary, TProduct, TransactionDocument } from "./mapper-library.model";
import { TRANSACTION_TYPE, Basket, LineDiscount, LinePromotions, Product, UserOverride } from "./mapper-library.model";
import { BasketService } from "./basket.service";
import { NumberUtilService } from "./number-util.service";
import {AppLoggerService} from '@pmcretail/common-services/common/app-logger.service';

/**
 * Transaction document builder
 */
export class TransactionDocumentBuilder {
  private transactionDocument: TransactionDocument;
  private numberUtilService: NumberUtilService;
  private storeInfo : any;
  className = "TransactionDocumentBuilder";
  
  constructor(
    transactionDoc?: TransactionDocument,
    private currencyPipe?: CurrencyPipe,
    private basketService?: BasketService | any,
  ) {
    this.numberUtilService = new NumberUtilService(currencyPipe);
    this.basketService = new BasketService(this.numberUtilService);
    this.storeInfo = JSON.parse(localStorage.getItem('storeInfo') || '{}');
    if (transactionDoc) {
      this.transactionDocument = transactionDoc;
    } else {
      this.transactionDocument = {
        transactionId: "",
        offlineTransactionId: "",
        transactionRef: "",
        dateTime: "",
        orgCode: "",
        storeId: "",
        storeNodeId: "",
        storeNodeStructure: "",
        deviceId: "",
        terminalId: "",
        userId: "",
        initiatingModule : "eBasket",
        export: false,
        basket: {} as TBasket,
        basketSummary: {} as BasketSummary,
        baseCurrency: "",
        type: "",
        operationStatus: "",
        createdAt: "",
        updatedAt: "",
        id: "",
        currentTransactionDetails: {} as CurrentTransactionDetails,
        saleTotal: 0,
      };
    }
  }

  /**
   * Transactions ref
   * @returns ref
   */
  transactionRef(): TransactionDocumentBuilder {
    const storeDetails = JSON.parse(localStorage.getItem('storeInfo') || '{}');
    const date = new Date();
    const random = (((1 + Math.random()) * 0x10000) | 0)
      .toString(16)
      .substring(1);
    this.transactionDocument.transactionRef =
      storeDetails.orgCode + storeDetails.storeId + date.toISOString() + random;
    AppLoggerService.logDebug(this.className, "transactionRef", "transaction ref created", this.transactionDocument.transactionRef)
    return this;
  }

  /**
   * Transactions id
   * @param transactionID
   * @returns id
   */
  transactionId(transactionID: string, isOnline: boolean = true): TransactionDocumentBuilder {
    if (isOnline) {
      this.transactionDocument.transactionId = transactionID;
    }
    return this;
  }

  /**
   * Transactions id
   * @param transactionID
   * @returns id
   */
  offlineTransactionId(transactionID: string, isOnline: any): TransactionDocumentBuilder {
    if (!isOnline) {
      this.transactionDocument.offlineTransactionId = transactionID;
    }
    return this;
  }

  /**
  * storeNode Id
  * @param storeNodeId
  * @returns id
  */
  storeNodeId(storeNodeId: string): TransactionDocumentBuilder {
    this.transactionDocument.storeNodeId = storeNodeId;
    return this;
  }

  /**
* storeNode structure
* @param storeNodeStructure
* @returns id
*/
  storeNodeStructure(storeNodeStructure: string): TransactionDocumentBuilder {
    this.transactionDocument.storeNodeStructure = storeNodeStructure;
    return this;
  }

  /**
   * Orgs code
   * @param orgCode
   * @returns code
   */
  orgCode(orgCode: any): TransactionDocumentBuilder {
    this.transactionDocument.orgCode = orgCode;
    return this;
  }
  /**
   * Stores id
   * @param storeId
   * @returns id
   */
  storeId(storeId: any): TransactionDocumentBuilder {
    this.transactionDocument.storeId = storeId;
    return this;
  }
  /**
   * Dates time
   * @returns time
   */
  dateTime(): TransactionDocumentBuilder {
    const date = new Date();
    this.transactionDocument.dateTime = date.toISOString();
    return this;
  }
  /**
   * Devices id
   * @param deviceId
   * @returns id
   */
  deviceId(deviceId: any): TransactionDocumentBuilder {
    this.transactionDocument.deviceId = deviceId;

    return this;
  }

  /**
     * terminal id
     * @param terminalId
     * @returns id
     */
  terminalId(terminalId: any): TransactionDocumentBuilder {
    this.transactionDocument.terminalId = terminalId;
    return this;
  }





  /**
    * saleExport
    * @param saleExport
    * @returns id
    */
  export(saleExport: any): TransactionDocumentBuilder {
    this.transactionDocument.export = saleExport;
    return this;
  }



  /*  customer(): TransactionDocumentBuilder {
    const user = JSON.parse(localStorage.getItem('userDetails'));
    this.transactionDocument.customer = user;
    return this;
  } */
  /**
   * Baskets transaction document builder
   * @param basketDetails
   * @returns basket
   */
  basket(basketDetails: Basket): TransactionDocumentBuilder {
    AppLoggerService.logDebug(this.className, "basket", "basket details update in transaction document", basketDetails);

    this.transactionDocument.subsidiaryId = basketDetails.subsidiaryId || (localStorage.getItem('subsidiaryId') || '');
    this.transactionDocument.basket.products = [] as TProduct[];
    this.transactionDocument.basket.lineDiscount = [];
    this.transactionDocument.basket.linePromotion = [];
    this.transactionDocument.basket.transactionPromotion = [];
    basketDetails.products.forEach((product: any, index) => {
      const p = {} as TProduct;
      p.itemDiscounts = {} as ItemDiscounts;
      p.SKU = product.SKU;
      p.excludePromotion = product.excludePromotion;
      p.barCode = product.barcode;
      p.barcodes = product.barcodes;
      p.description = product.description;
      p.itemLineId = product.itemLineId ? product.itemLineId.toString() : "" + (index + 1);
      p.price = product.selectedPrice;
      p.quantity = product.quantity;
      p.totalLinePrice = product.quantity * product.selectedPrice;
      p.imageUrls = product.imageUrls;
      p.selectedRRPPrice = product.selectedRRPPrice;

      //inventory fields
      
      p.fullfilmentId = product.fullfilmentId? product.fullfilmentId: this.storeInfo.storeId;

      p.fullfilmentLocationName = product.fullfilmentLocationName;
      p.deliveryGroup = product.deliveryGroup;
      p.leadTime = product.leadTime;
      p.deliveryMethod = product.deliveryMethod;

      p.giftCard = product.giftCard;
      p.giftCardExpiryDate = product.giftCardExpiryDate;
      p.giftCardNumberIssued = product.giftCardNumberIssued;
      p.giftCardRecipientEmail = product.giftCardRecipientEmail;
      p.giftCardRecipientName = product.giftCardRecipientName;

      if (product.refundedQuantity > 0) {
        p.refundedQuantity = product.refundedQuantity;
        p.refundedPromotionalQuantity = product.refundPromotionalQuantity;
        p.refunded = product.refunded;
        p.refundedReasonDescription = product.refundedReasonDescription;
        p.refundedReason = product.refundedReason;
        if (!p.refundedReasonDescription) {
          p.refundedReasonDescription = p.refundedReason;
        }
        p.refundedTotal = product.refundedTotal;
        p.isLastExchanged = product.isLastExchanged;
      }

      if (product.exchange) {
        p.exchange = product.exchange;
      }
      if (product.lineDiscount) {
        p.lineDiscount = product.lineDiscount;
      }
      p.itemDiscounts = product.itemDiscounts as ItemDiscounts;
      this.transactionDocument.basket.products.push(p);
      this.lineDiscount(basketDetails);
    });
    AppLoggerService.logInfo(this.className, "basket", "transactiondocument basket details updated", this.transactionDocument.basket);

    return this;
  }

  /**
     * current transaction Details Total(New Products)
     * @returns currentTransactionDetails
     */

  currentTransactionDetails(basket: Basket): TransactionDocumentBuilder {
    AppLoggerService.logDebug(this.className, "currentTransactionDetails", "current transaction details for exchanges", basket);
    this.transactionDocument.currentTransactionDetails.products = [] as Product[];
    this.transactionDocument.currentTransactionDetails.linePromotion = [] as LinePromotions[];
    this.transactionDocument.currentTransactionDetails.lineDiscount = [] as LineDiscount[];
    this.transactionDocument.currentTransactionDetails.transactionDiscount = [];
    this.transactionDocument.currentTransactionDetails.products = basket.products;
    this.transactionDocument.currentTransactionDetails.products = this.transactionDocument.currentTransactionDetails.products.filter(
      (      proj: { refundedQuantity: number; }) => proj.refundedQuantity != 0
    );

    this.transactionDocument.currentTransactionDetails.products.forEach((product: { refundedQuantity: any; quantity: any; totalLinePrice: number; refundedTotal: number; total: any; refunded: boolean; linePromotions: any; lineDiscount: any; }) => {
      if (product.refundedQuantity) {
        product.quantity = product.refundedQuantity;
        // updating total line price with actual price to be refunded including the refunding qty
        product.totalLinePrice = Math.abs(product.refundedTotal);
        product.total = product.totalLinePrice;
        if (product.quantity === product.refundedQuantity) {
          product.refunded = true;
        }
      }
      //Updating line promotions and line discounts      
      if (product.linePromotions && !product.refundedQuantity) {
        this.transactionDocument.currentTransactionDetails.linePromotion.push(product.linePromotions)
      }
      if (product.lineDiscount && !product.refundedQuantity) {
        this.transactionDocument.currentTransactionDetails.lineDiscount.push(product.lineDiscount)
      }
    });

    AppLoggerService.logDebug(this.className, "currentTransactionDetails", "current transaction details after removing old products", this.transactionDocument.currentTransactionDetails.products);

    if (basket.transactionDiscount && basket.transactionDiscount.length > 0) {
      this.transactionDocument.currentTransactionDetails.transactionDiscount.push(...basket.transactionDiscount);
    }
    this.transactionDocument.currentTransactionDetails.basketSummary = {} as BasketSummary;

    this.transactionDocument.currentTransactionDetails.basketSummary.saleTotal = this.numberUtilService.trimTo2Decimal2(this.updateSaleTotal(this.transactionDocument.currentTransactionDetails));
    this.transactionDocument.currentTransactionDetails.basketSummary.totalItems = basket.quantity;


    this.transactionDocument.currentTransactionDetails.basketSummary.basketTotal = basket.basketTotal;
    this.transactionDocument.currentTransactionDetails.basketSummary.refundTotal = this.updateCurrentTransactionDetailsRefundTotal();
    // For partial refund discount is updatied in total line price so discountTotal will always be zero & in case of exchange discount total is calculated

    if (this.transactionDocument.type === TRANSACTION_TYPE.SALE_EXCHANGE) {
      this.transactionDocument.currentTransactionDetails.basketSummary.discountTotal = this.numberUtilService.trimTo2Decimal2(this.updateCurrentTransactionDetailsDiscountTotal());
    } else {
      if (this.transactionDocument.currentTransactionDetails.transactionDiscount && this.transactionDocument.currentTransactionDetails.transactionDiscount.length > 0) {
        let discountTotal = 0;
        this.transactionDocument.currentTransactionDetails.transactionDiscount.forEach((discount: { discountAmount: number; }) => {
          discountTotal += discount.discountAmount;
        });
        this.transactionDocument.currentTransactionDetails.basketSummary.discountTotal = Math.abs(discountTotal);
      } else {
        this.transactionDocument.currentTransactionDetails.basketSummary.discountTotal = 0;
      }
    }

    AppLoggerService.logInfo(this.className, "currentTransactionDetails", "currentTransactionDetails", this.transactionDocument.currentTransactionDetails);
    return this;
  }


  /**
 * current transaction Tax Total
 * @returns Tax Total
 */

  updateCurrentTransactionDetailsTaxBreakdown(basketDetails: Basket): TransactionDocumentBuilder {
    let transactionDiscountTotal = 0;
    let taxBreakdown: TaxBreakdown = {
      taxLines: [],
      totalTaxableAmount: 0,
    };

    if (this.transactionDocument.currentTransactionDetails.transactionDiscount && this.transactionDocument.currentTransactionDetails.transactionDiscount.length > 0) {
      this.transactionDocument.currentTransactionDetails.transactionDiscount.forEach((discount: { discountAmount: number; }) => {
        transactionDiscountTotal += discount.discountAmount;
      });
    }

    if (this.transactionDocument.currentTransactionDetails.products && this.transactionDocument.currentTransactionDetails.products.length > 0) {
      this.transactionDocument.currentTransactionDetails.products.forEach((product: { itemLineId: any; selectedVAT: any; selectedVATCode: any; total: any; refundedQuantity: number; itemDiscounts: { currentRefundPortion: number; trnDiscountsPortion: number; trnPromotionsPortion: number; }; }) => {
        let taxLine: TaxLine = {
          itemLineId: product.itemLineId,
          VAT: product.selectedVAT ? product.selectedVAT : 0,
          VATCode: product.selectedVATCode,
          taxLineTotal: 0,
          taxableAmount: product.total,
          PreTax: 0

        };
        AppLoggerService.logInfo(this.className, "updateCurrentTransactionDetailsTaxBreakdown", `item line ID :current transaction Details",
          ${product.itemLineId}, tax line : ${taxLine}, basketDetails.basketTotal ${basketDetails.basketTotal}`);

        //step 1
        // if Transaction Discount and/or promotion applied, find net selling price of each product as taxableamount

        //If transaction discount/promotion is applied taxable amount should be deducting transaction promotion and transaction disacount portion
        if (product.refundedQuantity && product.refundedQuantity > 0) {

          taxLine.taxableAmount = -Math.abs(taxLine.taxableAmount - product.itemDiscounts.currentRefundPortion);
        } else {
          taxLine.taxableAmount = taxLine.taxableAmount - product.itemDiscounts.trnDiscountsPortion - product.itemDiscounts.trnPromotionsPortion;
        }

        //step 2 - find pre tax
        taxLine.PreTax = this.numberUtilService.trimTo2Decimal2((taxLine.taxableAmount * 100) / (100 + taxLine.VAT));

        //step 3 - Update taxbreakdown
        taxBreakdown.totalTaxableAmount += taxLine.taxableAmount;
        taxLine.taxableAmount = this.numberUtilService.trimTo2Decimal2(taxLine.taxableAmount);
        
        // step 4 - update tax Line total
        taxLine.taxLineTotal =  this.numberUtilService.trimTo2Decimal2(taxLine.taxableAmount - taxLine.PreTax);
        taxBreakdown.taxLines.push(taxLine);
      });
    }

    taxBreakdown.totalTaxableAmount = this.numberUtilService.trimTo2Decimal2(taxBreakdown.totalTaxableAmount);
    this.transactionDocument.currentTransactionDetails.taxBreakdown = taxBreakdown;
    if (this.transactionDocument.currentTransactionDetails.taxBreakdown && this.transactionDocument.currentTransactionDetails.taxBreakdown.taxLines && this.transactionDocument.currentTransactionDetails.taxBreakdown.taxLines.length > 0) {
      this.transactionDocument.currentTransactionDetails.basketSummary.VATTotal = this.numberUtilService.trimTo2Decimal2(this.transactionDocument.currentTransactionDetails.taxBreakdown.taxLines.reduce(
        (n: any, { taxLineTotal }: any) => n + taxLineTotal,
        0
      ));
    }
    else {
      this.transactionDocument.currentTransactionDetails.basketSummary.VATTotal = 0.00;
    }

    AppLoggerService.logDebug(this.className, "updateCurrentTransactionDetailsTaxBreakdown", "eBasket:after calculating tax currenttransactionDetails", this.transactionDocument.currentTransactionDetails)
    return this;
  }

  updateCurrentTransactionDetailsTotalTaxSummary(): TransactionDocumentBuilder {
  
    AppLoggerService.logDebug(this.className, "updateCurrentTransactionDetailsTotalTaxSummary", "Total Tax Summery Request :", this.transactionDocument.currentTransactionDetails.taxBreakdown);

    let totalTaxSummaryArray: TotalTaxSummary[] = []
    let totalTaxSummaryGroup = []


    this.transactionDocument.currentTransactionDetails.taxBreakdown.taxLines.forEach((element: { VATCode: any; VAT: any; PreTax: any; taxLineTotal: any; }) => {
      let TaxSummary: TotalTaxSummary = {
        VATCode:"",
        VAT: -12345,
        PreTaxSum: 0,
        TaxSum: 0,
        TXrateSum: 0
      };
        TaxSummary.VATCode=element.VATCode;
        TaxSummary.VAT = element.VAT;        
       
        TaxSummary.PreTaxSum = this.numberUtilService.trimTo2Decimal2(element.PreTax);        
        TaxSummary.TaxSum = this.numberUtilService.trimTo2Decimal2(element.taxLineTotal);
        TaxSummary.TXrateSum = this.numberUtilService.trimTo2Decimal2(TaxSummary.PreTaxSum + TaxSummary.TaxSum);     
        totalTaxSummaryArray.push(TaxSummary);
    })

    AppLoggerService.logDebug(this.className, "updateCurrentTransactionDetailsTotalTaxSummary", "Total Tax Summery  Without Grouped : ", totalTaxSummaryArray);
    
    totalTaxSummaryGroup = totalTaxSummaryArray.reduce((preparedArray:any,currentObj:any) => {
      let ind = preparedArray.findIndex((x: { VAT: any; }) => x.VAT === currentObj.VAT);
      if(ind === -1){
        preparedArray.push(currentObj)
      }else {
        preparedArray[ind].VATCode = currentObj.VATCode;
        preparedArray[ind].VAT = currentObj.VAT;
        preparedArray[ind].PreTaxSum += currentObj.PreTaxSum;
        preparedArray[ind].TaxSum += currentObj.TaxSum;
        preparedArray[ind].TXrateSum += currentObj.TXrateSum;
      }
      return preparedArray;
    },[])
    // listOfTags.map(x => unique.filter(a => a.label == x.label && a.color == x.color).length > 0 ? null : unique.push(x));

    AppLoggerService.logDebug(this.className, "updateCurrentTransactionDetailsTotalTaxSummary", "Total  Tax Summer Group :", totalTaxSummaryGroup);

    this.transactionDocument.currentTransactionDetails.totalTaxSummary = totalTaxSummaryGroup;
    return this;

  }

  /**
   * current transaction Disocunt Total
   * @returns Discount Total
   */
  updateCurrentTransactionDetailsDiscountTotal() {
    let refundTotal = this.transactionDocument.currentTransactionDetails.basketSummary.refundTotal ? this.transactionDocument.currentTransactionDetails.basketSummary.refundTotal : 0;

    AppLoggerService.logDebug(this.className, "updateCurrentTransactionDetailsDiscountTotal",  `refundTotal ${refundTotal}, basketTotal ${this.transactionDocument.currentTransactionDetails.basketSummary.basketTotal},saleTotal  ${this.transactionDocument.currentTransactionDetails.basketSummary.saleTotal}`);
    const discountTotal =
      Math.abs(
        Math.abs(this.transactionDocument.currentTransactionDetails.basketSummary.saleTotal) -
        (Math.abs(this.transactionDocument.currentTransactionDetails.basketSummary.basketTotal) + Math.abs(refundTotal))
      );
    AppLoggerService.logDebug(this.className, "updateCurrentTransactionDetailsDiscountTotal", "discountTotal", discountTotal)
    return Number(discountTotal.toFixed(2));
  }

  /**
  * current transaction Refund Total
  * @returns Refund Total
  */
  updateCurrentTransactionDetailsRefundTotal() {
    let totalRefund = 0;
    for (let index = 0; index < this.transactionDocument.currentTransactionDetails.products.length; index++) {
      const product: Product = this.transactionDocument.currentTransactionDetails.products[index];
      if (product.refundedTotal) {
        totalRefund = totalRefund + product.refundedTotal;
      }
      AppLoggerService.logDebug(this.className, "updateCurrentTransactionDetailsRefundTotal", "totalRefund for Current TransactionDetails" , totalRefund)
    }
    return totalRefund;
  }



  /**
   * Baskets summary
   * @param basketDetails
   * @returns summary
   */
  basketSummary(basketDetails: Basket): TransactionDocumentBuilder {
    this.transactionDocument.basketSummary.basketTotal = this.numberUtilService.trimTo2Decimal(basketDetails.basketTotal);

    this.transactionDocument.basketSummary.saleTotal = this.numberUtilService.trimTo2Decimal2(this.updateSaleTotal(
      basketDetails
    ));
    this.transactionDocument.basketSummary.refundTotal = this.getRefundTotal();
    if (
      this.transactionDocument.basket.lineDiscount ||
      this.transactionDocument.basket.linePromotion
    ) {
      this.transactionDocument.basketSummary.discountTotal = this.numberUtilService.trimTo2Decimal2(this.updateDiscountTotal());
    }
    this.transactionDocument.basketSummary.totalItems = basketDetails.quantity;


    if (this.transactionDocument.basket.taxBreakdown) {
      this.transactionDocument.basketSummary.VATTotal = this.numberUtilService.trimTo2Decimal2(this.transactionDocument.basket.taxBreakdown.taxLines.reduce(
        (n: any, { taxLineTotal }: any) => n + taxLineTotal,
        0
      ));
    }
    else {
      this.transactionDocument.basketSummary.VATTotal = 0.00;
    }

    AppLoggerService.logInfo(this.className, "basketSummary", "basketsummary updated in transaction document: ", this.transactionDocument.basketSummary);
    return this;
  }

  /**
   * Line Discount
   * @param basketDetails
   * @returns line Discount
   */
  lineDiscount(basketDetails: Basket): TransactionDocumentBuilder {
    this.transactionDocument.basket.lineDiscount = [];
    for (let index = 0; index < basketDetails.products.length; index++) {
      const element = basketDetails.products[index];
      if (element.lineDiscount) {
        this.transactionDocument.basket.lineDiscount.push(element.lineDiscount);
        this.transactionDocument.basket.lineDiscount = this.transactionDocument.basket.lineDiscount.reduce(
          (acc: any[], val: { itemLineId: any; }) => {
            if (!acc.find((el: { itemLineId: any; }) => el.itemLineId === val.itemLineId)) {
              acc.push(val);
            }
            return acc;
          },
          []
        );
      }

      // AppLoggerService.logInfo(this.className, 
      //   "e-basket :line discount updated in transaction document",
      //   this.transactionDocument.basket.lineDiscount
      // );
    }
    return this;
  }

  /**
   * exchange
   * @param basketDetails
   * @returns exchange 
   */
  exchange(basketDetails: Basket): TransactionDocumentBuilder {
    this.transactionDocument.basket.exchange = basketDetails.exchange && basketDetails.exchange.length > 0 ? [...basketDetails.exchange] : [];
    for (let index = 0; index < basketDetails.products.length; index++) {

      const element: any = basketDetails.products[index];
      if (element.exchange != undefined) {
        const isPresent = this.transactionDocument.basket.exchange.some((el: { exchangeId: any; }) => el.exchangeId === element.exchange.exchangeId);
        if (!isPresent) {
          let exchangeItems = [];
          for (let j = 0; j < element.exchange.newItems.length; j++) {
            const item = element.exchange.newItems[j];
            let newItems: any = { lineItemId: item.itemLineId, Quantity: item.quantity }
            exchangeItems.push(newItems);
          }
          element.exchange.newItems = [...exchangeItems];
          this.transactionDocument.basket.exchange.push(element.exchange);
        }
      }
      AppLoggerService.logDebug(this.className, "exchange",
        "this.transactionDocument.basket exchange",
        this.transactionDocument.basket.exchange
      );
    }

    return this;
  }

  /**
  * add previous exchange data
  * @param originalTransactionDocument
  * @returns line Promotions
  */
  addExchangeData(originalTransactionDocument: TransactionDocument): TransactionDocumentBuilder {
    this.transactionDocument.basket.exchange = originalTransactionDocument.basket.exchange ? [...originalTransactionDocument.basket.exchange] : null;
    return this;
  }

  /**
   * line Promotions
   * @param basketDetails
   * @returns line Promotions
   */
  linePromotion(basketDetails: Basket): TransactionDocumentBuilder {
    this.transactionDocument.basket.linePromotion = [];
    for (let index = 0; index < basketDetails.products.length; index++) {
      const element = basketDetails.products[index];
      if (element.linePromotions) {
        this.transactionDocument.basket.linePromotion.push(
          element.linePromotions
        );
        this.transactionDocument.basket.linePromotion = this.transactionDocument.basket.linePromotion.reduce(
          (acc: any[], val: { itemLineId: any; }) => {
            if (!acc.find((el: { itemLineId: any; }) => el.itemLineId === val.itemLineId)) {
              acc.push(val);
            }
            return acc;
          },
          []
        );
      }
    }
    return this;
  }

  /**
   * transaction Promotion
   * @param basketDetails
   * @returns transaction Promotion
   */
  transactionPromotion(basketDetails: Basket): TransactionDocumentBuilder {
    if (basketDetails.transactionPromotion) {
      this.transactionDocument.basket.transactionPromotion =
        basketDetails.transactionPromotion;
      //   for (let index = 0; index < basketDetails.TransactionDiscount.length; index++) {
      //   this.transactionDocument.basket.transactionPromotion.push(element.linePromotions)
      //   this.transactionDocument.basket.transactionPromotion =  this.transactionDocument.basket.linePromotions.reduce((acc, val) => {
      //     if (!acc.find(el => el.itemLineId === val.itemLineId)) {
      //       acc.push(val);
      //     }
      //     return acc;
      //   }, []);
      // }
      AppLoggerService.logDebug(this.className, "transactionPromotion",
        "this.transactionDocument.basket.transactionPromotion",
        this.transactionDocument.basket.transactionPromotion
      );
    }
    return this;
  }

  transactionDiscount(basketDetails: Basket): TransactionDocumentBuilder {
    if (basketDetails.transactionDiscount) {
      this.transactionDocument.basket.transactionDiscount =
        basketDetails.transactionDiscount;

      AppLoggerService.logDebug(this.className, "transactionDiscount",
        "transaction Discount",
        this.transactionDocument.basket.transactionDiscount
      );
    }
    return this;
  }

  /**
   * Payments details
   * @param paymentDetails
   * @returns
   */
  paymentDetails(paymentDetails: any) {
    AppLoggerService.logInfo(this.className, "paymentDetails", "payment details after transaction completed",paymentDetails);
    
    this.transactionDocument.paymentDetails = paymentDetails;
    return this;
  }


  /**
   * Payments details
   * @param paymentDetails
   * @returns
   */
   splitPayment(splitPayment: boolean) {    
    this.transactionDocument.splitPayment = splitPayment;
    return this;
  } 

   /**
   * Payments details
   * @param paymentDetails
   * @returns
   */
    isPaymentCompleted(isPaymentCompleted: boolean) {
      this.transactionDocument.isPaymentCompleted = isPaymentCompleted;
      return this;
    } 
  



  /**
   * Bases currency
   * @param currency
   * @returns currency
   */
  baseCurrency(currency: any): TransactionDocumentBuilder {
    this.transactionDocument.baseCurrency = currency;
    return this;
  }

  /**
  * gift option at
  * @returns at
  */
  giftOption(gift: any): TransactionDocumentBuilder {
    AppLoggerService.logDebug(this.className, "giftOption",
      "this.transactionDocument.giftoption",
      gift
    );
    if (gift) {
      this.transactionDocument.giftedReceipt = gift;
    }
    return this;
  }
  /**

/**
 * manual Discount
 * @param discountData
 * @returns
 */

  // manualDiscount(discountData : basketDiscount):TransactionDocumentBuilder {
  //   let saleTotal =  this.transactionDocument.basketSummary.basketTotal;
  //   if(discountData.discountType =='Percent'){
  //     this.transactionDocument.basketSummary.basketTotal = saleTotal-(saleTotal*(discountData.discountAmount/100));
  //     discountData.discountAmount = -1*(saleTotal-this.transactionDocument.basketSummary.basketTotal);
  //   }else {
  //     this.transactionDocument.basketSummary.basketTotal =saleTotal-discountData.discountAmount;
  //     discountData.discountAmount = -1*discountData.discountAmount;
  //   }
  //   this.transactionDocument.transactionDiscount.push(discountData);
  //   return this;

  // }

  /**
   * Types transaction document builder
   * @param t
   * @returns type
   */
  type(t: any): TransactionDocumentBuilder {
    this.transactionDocument.type = t;
    return this;
  }
  /**
   * Operations status
   * @param o
   * @returns status
   */
  operationStatus(o: any): TransactionDocumentBuilder {
    this.transactionDocument.operationStatus = o;
    return this;
  }
  /**
   * Created at
   * @returns at
   */
  createdAt(): TransactionDocumentBuilder {
    const date = new Date();
    this.transactionDocument.createdAt = date.toISOString();
    this.transactionDocument.updatedAt = date.toISOString();
    return this;
  }
  /**
   * Updated at
   * @returns at
   */
  updatedAt(): TransactionDocumentBuilder {
    const date = new Date();
    this.transactionDocument.updatedAt = date.toISOString();
    return this;
  }
  /**
   * transsaction completion at
   * @returns transaction completion date
   */
  transactionCompletedAt(): TransactionDocumentBuilder {
    const date = new Date();
    this.transactionDocument.transCompletedAt = date.toISOString();
    return this;
  }
  /**
   * Builds transaction document builder
   * @returns build
   */
  build(): TransactionDocument {
    return this.transactionDocument;
  }

  /**
   * Sales total in refund
   * @param saleTotal
   * @returns total in refund
   */
  saleTotalInRefund(saleTotal: number): TransactionDocumentBuilder {
    this.transactionDocument.saleTotal = saleTotal;
    return this;
  }

  /**
   * Gets basket details
   * @returns basket details
   */
  getBasketDetails(): Basket {
    AppLoggerService.logInfo(this.className, "getBasketDetails", "Getting Basket for transactionDocument", this.transactionDocument);

    let basket: Basket = {
      subsidiaryId : this.transactionDocument.subsidiaryId,
      transactionDiscount: this.transactionDocument.basket.transactionDiscount,
      transactionPromotion: this.transactionDocument.basket.transactionPromotion,
      transactionId: this.transactionDocument.transactionId,
      offlineTransactionId: this.transactionDocument.offlineTransactionId,
      total: this.transactionDocument.basketSummary.basketTotal,
      basketTotal: this.transactionDocument.basketSummary.basketTotal,
      discountTotal: this.transactionDocument.basketSummary.discountTotal,
      saleTotal: this.transactionDocument.basketSummary.saleTotal,
      refundTotal: this.transactionDocument.basketSummary.refundTotal,
      quantity: this.transactionDocument.basketSummary.totalItems,
      products: [],
      baseCurrency: this.transactionDocument.baseCurrency,
      customer: this.transactionDocument.customer,
    };

    basket.products = [] as Product[];
    this.transactionDocument.basket.products.forEach((product: { SKU: any; barCode: any; barcodes: any; description: any; imageUrls: any; totalLinePrice: any; itemLineId: any; excludePromotion: any; price: any; quantity: any; selectedRRPPrice: any; fullfilmentId: any; fullfilmentLocationName: any; deliveryGroup: string; leadTime: any; deliveryMethod: any; giftCard: any; giftCardExpiryDate: any; giftCardNumberIssued: any; giftCardRecipientEmail: any; giftCardRecipientName: any; refundedTotal: any; refundedQuantity: number; refundedReasonDescription: any; refundedReason: any; refundedPromotionalQuantity: any; isLastExchanged: any; }, index: any) => {
      AppLoggerService.logDebug(this.className, JSON.stringify(product), "ebasket: basket detail update in basket");
      const p = {} as any;
      p.SKU = product.SKU;
      p.barcode = product.barCode;
      p.barcodes = product.barcodes;

      p.description = product.description;
      p.imageUrls = product.imageUrls;
      p.currency = this.transactionDocument.baseCurrency;
      p.totalLinePrice = product.totalLinePrice;
      p.itemLineId = Number(product.itemLineId);
      p.excludePromotion = product.excludePromotion;

      p.selectedPrice = product.price;
      p.quantity = product.quantity;
      p.total = product.totalLinePrice;
      p.selectedRRPPrice = product.selectedRRPPrice;

      p.fullfilmentId = product.fullfilmentId;
      p.fullfilmentLocationName = product.fullfilmentLocationName;
      p.deliveryGroup = product.deliveryGroup || "1";
      p.leadTime = product.leadTime;
      p.deliveryMethod = product.deliveryMethod || DELIVERY_METHODS.COLLECT_FROM_STORE.toString();

      if(p.fullfilmentId != this.transactionDocument.storeId)
      {
        p.isWebOrder = true;
      }
    
      p.giftCard = product.giftCard;
      p.giftCardExpiryDate = product.giftCardExpiryDate;
      p.giftCardNumberIssued = product.giftCardNumberIssued;
      p.giftCardRecipientEmail = product.giftCardRecipientEmail;
      p.giftCardRecipientName = product.giftCardRecipientName;
      
      if (
        this.transactionDocument.basket.lineDiscount &&
        this.transactionDocument.basket.lineDiscount.length > 0
      ) {
        this.transactionDocument.basket.lineDiscount.forEach((lineDiscount: { itemLineId: { toString: () => any; }; discountedLinePrice: any; }) => {
          if (product.itemLineId === lineDiscount.itemLineId.toString()) {
            p.lineDiscount = lineDiscount;
            p.total = lineDiscount.discountedLinePrice;
          }
        });
      }

      if (
        this.transactionDocument.basket.linePromotion &&
        this.transactionDocument.basket.linePromotion.length > 0
      ) {
        this.transactionDocument.basket.linePromotion.forEach((linePromotion: { itemLineId: { toString: () => any; }; promotionLinePrice: any; }) => {
          if (product.itemLineId === linePromotion.itemLineId.toString()) {
            p.linePromotions = linePromotion;
            p.total = linePromotion.promotionLinePrice;
          }
        });
      }

      if (
        this.transactionDocument.basket.taxBreakdown &&
        this.transactionDocument.basket.taxBreakdown.taxLines.length > 0
      ) {
        this.transactionDocument.basket.taxBreakdown.taxLines.forEach((taxLine: { itemLineId: { toString: () => any; }; VAT: any; VATCode: any; }) => {
          if (product.itemLineId && product.itemLineId === taxLine.itemLineId.toString()) {
            p.selectedVAT = taxLine.VAT;
            p.selectedVATCode = taxLine.VATCode;
          }
        });
      }

      if (this.transactionDocument.type === TRANSACTION_TYPE.REFUND) {
        p.total = product.refundedTotal;
      } else if ((this.transactionDocument.type === TRANSACTION_TYPE.SALE_REFUND || TRANSACTION_TYPE.SALE_EXCHANGE) && product.refundedQuantity > 0) {
        p.refundedReasonDescription = product.refundedReasonDescription;
        p.refundedReason = product.refundedReason;
        if (!p.refundedReasonDescription) {
          p.refundedReasonDescription = p.refundedReason;
        }
        p.refundedQuantity = product.refundedQuantity;
        p.refundPromotionalQuantity = product.refundedPromotionalQuantity;
        p.refundedTotal = product.refundedTotal;
        p.total -= Math.abs(p.refundedTotal);
        p.isLastExchanged = product.isLastExchanged;
      }

      if (this.transactionDocument.type === TRANSACTION_TYPE.REFUND) {
        if (p.total > 0) {
          p.total *= -1;
        }
      }

      basket.products.push(p);

    });

    basket = this.getTransactionDiscountAndTransactionPromotionPortion(basket);
    basket.total = (basket.basketTotal || 0) + this.getTotalDiscountWithTransactionDiscountsAndPromotions(basket);
    if (this.transactionDocument.type === TRANSACTION_TYPE.SALE_REFUND) {
      basket.quantity = this.getRefundedTotalWithQuantity(basket);
    }
    AppLoggerService.logInfo(this.className, "getBasketDetails", "Basket created successfully", basket)
    return basket;
  }

  /**
   * Gets basket details
   * @returns refund basket details
   */
  // getRefundBasketDetails(): Basket {
  //   let basket: Basket = {
  //     subsidiaryId : this.transactionDocument.subsidiaryId,
  //     transactionDiscount: this.transactionDocument.basket.transactionDiscount,
  //     transactionPromotion: this.transactionDocument.basket.transactionPromotion,
  //     transactionId: this.transactionDocument.transactionId,
  //     total: this.transactionDocument.basketSummary.basketTotal,
  //     basketTotal: this.transactionDocument.basketSummary.basketTotal,
  //     discountTotal: this.transactionDocument.basketSummary.discountTotal,
  //     saleTotal: this.transactionDocument.basketSummary.saleTotal,
  //     quantity: this.transactionDocument.basketSummary.totalItems,
  //     products: [],
  //     baseCurrency: this.transactionDocument.baseCurrency,
  //     customer: this.transactionDocument.customer,
  //   };

  //   basket.products = [] as Product[];
  //   this.transactionDocument.basket.products.forEach((product: { SKU: any; barCode: any; barcodes: any; description: any; imageUrls: any; totalLinePrice: any; itemLineId: any; excludePromotion: any; price: number; quantity: any; selectedRRPPrice: any; fullfilmentId: any; fullfilmentLocationName: any; deliveryGroup: string; leadTime: any; deliveryMethod: any; giftCard: any; giftCardExpiryDate: any; giftCardNumberIssued: any; giftCardRecipientEmail: any; giftCardRecipientName: any; itemDiscounts: any; refundedPromotionalQuantity: any; refundedQuantity: number; refunded: any; isLastExchanged: any; exchange: any; refundedTotal: number; }, index: any) => {
  //     const p = {} as Product;
  //     p.SKU = product.SKU;
  //     p.barcode = product.barCode;
  //     p.barcodes = product.barcodes;

  //     p.description = product.description;
  //     p.imageUrls = product.imageUrls;
  //     p.currency = this.transactionDocument.baseCurrency;
  //     p.totalLinePrice = product.totalLinePrice;
  //     p.itemLineId = Number(product.itemLineId);
  //     p.excludePromotion = product.excludePromotion;

  //     p.selectedPrice = product.price;
  //     p.quantity = product.quantity;
  //     p.total = product.totalLinePrice;
  //     p.selectedRRPPrice = product.selectedRRPPrice;

  //     p.fullfilmentId = product.fullfilmentId;
  //     p.fullfilmentLocationName = product.fullfilmentLocationName;
  //     p.deliveryGroup = product.deliveryGroup || "1";
  //     p.leadTime = product.leadTime;
  //     p.deliveryMethod = product.deliveryMethod || DELIVERY_METHODS.COLLECT_FROM_STORE.toString();

  //     p.giftCard = product.giftCard;
  //     p.giftCardExpiryDate = product.giftCardExpiryDate;
  //     p.giftCardNumberIssued = product.giftCardNumberIssued;
  //     p.giftCardRecipientEmail = product.giftCardRecipientEmail;
  //     p.giftCardRecipientName = product.giftCardRecipientName;
      
      
  //     if(p.fullfilmentId != this.transactionDocument.storeId)
  //     {
  //       p.isWebOrder = true;
  //     }
      
  //     if (product.itemDiscounts) {
  //       p.itemDiscounts = product.itemDiscounts as ItemDiscount;
  //     }

  //     // if(!p.itemDiscounts){
  //     //   AppLoggerService.logDebug(this.className, p.itemDiscounts);

  //     //   this.basketService.transactionDiscountAndPromotionProductortionCalculation(basket);
  //     // }
  //     p.refundPromotionalQuantity = product.refundedPromotionalQuantity ? product.refundedPromotionalQuantity : 0;

  //     if (product.refundedQuantity) {
  //       p.quantity = p.quantity - product.refundedQuantity;
  //       p.totalLinePrice = (p.quantity * product.price);
  //       p.total = p.totalLinePrice;
  //       // p.refundPromotionalQuantity = product.refundedPromotionalQuantity;
  //       p.refunded = product.refunded;
  //       p.isLastExchanged = product.isLastExchanged;
  //     }
  //     if (product.exchange) {
  //       p.exchange = product.exchange;
  //     }

  //     if (
  //       this.transactionDocument.basket.lineDiscount &&
  //       this.transactionDocument.basket.lineDiscount.length > 0
  //     ) {

  //       this.transactionDocument.basket.lineDiscount.forEach((lineDiscount: { itemLineId: { toString: () => any; }; discountedLinePrice: any; }) => {

  //         if (product.itemLineId === lineDiscount.itemLineId.toString() && product.refundedQuantity > 0) {
  //           p.lineDiscount = Object.assign({}, lineDiscount);
  //           p.lineDiscount.discountedLinePrice = p.lineDiscount.unitPrice * p.quantity
  //           p.lineDiscount.discountAmount = p.total - p.lineDiscount.discountedLinePrice
  //           p.total = p.lineDiscount.discountedLinePrice;
  //         } else if (product.itemLineId === lineDiscount.itemLineId.toString()) {
  //           p.lineDiscount = lineDiscount;
  //           p.total = lineDiscount.discountedLinePrice
  //         }
  //       });
  //     }

  //     if (
  //       this.transactionDocument.basket.linePromotion &&
  //       this.transactionDocument.basket.linePromotion.length > 0
  //     ) {
  //       this.transactionDocument.basket.linePromotion.forEach((linePromotion: { itemLineId: { toString: () => any; }; refunded: any; }) => {
  //         if (product.itemLineId === linePromotion.itemLineId.toString() && !linePromotion.refunded) {
  //           p.linePromotions = linePromotion;
  //           p.total = p.linePromotions.promotionLinePrice;
  //           p.total = p.total - (product.refundedTotal ? Math.abs(product.refundedTotal) : 0);
  //         }
  //       });
  //     }

  //     p.refundedQuantity = 0;
  //     p.refundedTotal = 0;

  //     if (
  //       this.transactionDocument.basket.taxBreakdown &&
  //       this.transactionDocument.basket.taxBreakdown.taxLines.length > 0
  //     ) {
  //       this.transactionDocument.basket.taxBreakdown.taxLines.forEach((taxLine: { itemLineId: { toString: () => any; }; VAT: any; VATCode: any; }) => {
  //         if (product.itemLineId === taxLine.itemLineId.toString()) {
  //           p.selectedVAT = taxLine.VAT;
  //           p.selectedVATCode = taxLine.VATCode;
  //         }
  //       });
  //     }

  //     if (p.quantity > 0) {
  //       basket.products.push(p);
  //     }
  //   });
  //   // product.itemDiscounts
  //   if (!basket.products[0].hasOwnProperty('itemDiscounts')) {
  //     basket = this.getTransactionDiscountAndTransactionPromotionPortion(basket);

  //   }

  //   AppLoggerService.logDebug(this.className, "ebasket : TransactionDocumentBuilder  :new created refunded basket", JSON.stringify(basket))
  //   basket.quantity = basket.products.reduce(
  //     (n: any, { quantity }: any) => n + quantity,
  //     0
  //   );
  //   basket.total = this.getTotalWithLineDiscountAndLinePromotionApplied(basket);
  //   basket.basketTotal = basket.total;
  //   basket.basketTotal = basket.basketTotal - this.getTotalDiscountWithTransactionDiscountsAndPromotions(basket);
  //   AppLoggerService.logDebug(this.className, 
  //     "ebasket : TransactionDocumentBuilder : update Basket Total: after promotion :basketTotal",
  //     basket.basketTotal
  //   );

  //   AppLoggerService.logDebug(this.className, 
  //     "e:basket :TransactionDocumentBuilder : basketDetails updated values",
  //     JSON.stringify(basket)
  //   );
  //   return basket;
  // }


  getTransactionDiscountAndTransactionPromotionPortion(basket:any) {
    if (
      basket.transactionDiscount &&
      basket.transactionDiscount.length > 0
    ) {
      basket.transactionDiscount.forEach((discount: { itemLineIds: any; }) => {
        if (!discount.itemLineIds) {
          discount.itemLineIds = basket.products.map((product: { itemLineId: any; }) => {
            return product.itemLineId
          });
        }
        basket = this.basketService.transactionDiscountProductPortionCalc(basket, discount);
      });
    }
    if (
      basket.transactionPromotion &&
      basket.transactionPromotion.length > 0
    ) {
      basket.transactionPromotion.forEach((tPromotion: { itemLineIds: any; }) => {
        if (!tPromotion.itemLineIds) {
          const filteredData = basket.products.filter(
            (item: { excludePromotion: boolean; }) => {
              return item.excludePromotion === false;
            });

          tPromotion.itemLineIds =
            filteredData.map((product: { itemLineId: any; }) => {
              return product.itemLineId
            });
        }
        basket = this.basketService.transactionPromotionProductPortionCalc(basket, tPromotion);
      });
    }

    return basket;
  }


  getTotalDiscountWithTransactionDiscountsAndPromotions(basketDetails: any) {

    let discountTotal = 0;
    if (
      basketDetails.transactionPromotion &&
      basketDetails.transactionPromotion.length > 0
    ) {
      discountTotal += basketDetails.transactionPromotion.reduce(
        (n: any, { promotionAmount }: any) => n + promotionAmount,
        0
      );
    }
    if (
      basketDetails.transactionDiscount &&
      basketDetails.transactionDiscount.length > 0
    ) {

      discountTotal += basketDetails.transactionDiscount.reduce(
        (n: any, { discountAmount }: any) => n + discountAmount,
        0
      );


    }
    AppLoggerService.logDebug(this.className, "getTotalDiscountWithTransactionDiscountsAndPromotions", "Transaction discount Total:", discountTotal);

    return discountTotal;
  }


  appendCurrencySymbol(currency: number, value: number) {
    //  value=this.decimalpipe.transform(value,'1.2');
    if (value >= 0) {
      const returnval = currency + value;
      AppLoggerService.logDebug(this.className, "appendCurrencySymbol", "add currency with value", returnval);
      return returnval;
    } else {
      const returnval = "-" + (currency + value * -1);
      AppLoggerService.logDebug(this.className, "appendCurrencySymbol", "returnVal", returnval);
      return returnval;
    }
  }

  // /**
  //  * Updates total refund
  //  * @returns total refund
  //  */
  // updateTotalRefund(): TransactionDocumentBuilder {
  //   this.transactionDocument.basket.products.forEach((product) => {
  //     product.refundedQuantity = product.quantity;
  //     product.refundedTotal = product.totalLinePrice * -1;
  //     AppLoggerService.logDebug(this.className, 
  //       "ebasket: Transaction price override :",
  //       this.transactionDocument.basket.lineDiscount
  //     );

  //     if (
  //       this.transactionDocument.basket.linePromotion &&
  //       this.transactionDocument.basket.linePromotion.length > 0
  //     ) {
  //       this.transactionDocument.basket.linePromotion.forEach((linePromotion) => {
  //         AppLoggerService.logDebug(this.className, 
  //           "Promotion: basket linePromotion : ",
  //           this.transactionDocument.basket.linePromotion
  //         );
  //         AppLoggerService.logDebug(this.className, 
  //           "linePromotion.itemLineId.toString() : ",
  //           linePromotion.itemLineId.toString()
  //         );
  //         AppLoggerService.logDebug(this.className, 
  //           "condition : " +
  //           (product.itemLineId === linePromotion.itemLineId.toString())
  //         );

  //         if (product.itemLineId === linePromotion.itemLineId.toString()) {
  //           product.refundedTotal =
  //             linePromotion.promotionLinePrice * -1;
  //         }
  //       });
  //     } else
  //       if (
  //         this.transactionDocument.basket.lineDiscount &&
  //         this.transactionDocument.basket.lineDiscount.length > 0
  //       ) {
  //         this.transactionDocument.basket.lineDiscount.forEach((lineDiscount) => {
  //           AppLoggerService.logDebug(this.className, 
  //             "product.itemLineId : " +
  //             this.transactionDocument.basket.lineDiscount
  //           );
  //           AppLoggerService.logDebug(this.className, 
  //             "lineDiscount.itemLineId.toString() : " +
  //             lineDiscount.itemLineId.toString()
  //           );
  //           AppLoggerService.logDebug(this.className, 
  //             "condition : " +
  //             (product.itemLineId === lineDiscount.itemLineId.toString())
  //           );

  //           if (product.itemLineId === lineDiscount.itemLineId.toString()) {
  //             product.refundedTotal = lineDiscount.unitPrice * product.refundedQuantity * -1;
  //           }
  //         });
  //       }

  //     AppLoggerService.logDebug(this.className, "Product description :" + product.description);
  //     AppLoggerService.logDebug(this.className, "Product total :" + product.refundedTotal);
  //     // product.displayrefundedamount=this.appendCurrencySymbol(CURRENCY[this.transactionDocument.baseCurrency],product.refundedTotal);
  //     // AppLoggerService.logDebug(this.className, product.displayrefundedamount,"displayrefundedamount");
  //     product.refunded = true;
  //   });
  //   const baskettotal = (this.transactionDocument.basketSummary.basketTotal *= -1);
  //   // this.transactionDocument.basketSummary.displaybaskettotal=this.appendCurrencySymbol(CURRENCY[this.transactionDocument.baseCurrency], baskettotal);
  //   const saletotal = (this.transactionDocument.basketSummary.saleTotal *= -1);
  //   // this.transactionDocument.basketSummary.displaysaletotal = this.appendCurrencySymbol(CURRENCY[this.transactionDocument.baseCurrency], saletotal);
  //   (this.transactionDocument.basketSummary.VATTotal *= -1);
  //   return this;
  // }

  /**
   * Sale Total
   * @param basketDetails
   * @returns Sale Total
   */
  updateSaleTotal(basketDetails: { products: any[]; }) {
    const saleTotal = basketDetails.products.reduce(
      (n: any, { totalLinePrice }: any) => n + totalLinePrice,
      0
    );
    return saleTotal
  }

  getTotalWithLineDiscountAndLinePromotionApplied(basketDetails: { products: any; }): number {
    let saletotal: number = 0.0;
    for (let product of basketDetails.products) {
      // if (product.linePromotions) {
      //   saletotal += product.linePromotions.promotionLinePrice;
      // } else if (
      //   product.lineDiscount &&
      //   !product.linePromotions
      // ) {
      //   saletotal +=
      //     product.quantity * Number(product.lineDiscount.unitPrice.toFixed(2));
      // } else {
      //   saletotal +=
      //     product.quantity * Number(product.selectedPrice.toFixed(2));
      // }
      saletotal += product.total;
      AppLoggerService.logDebug(this.className, "getTotalWithLineDiscountAndLinePromotionApplied",
        "e-basket:update product Total:" + saletotal,
        product
      );
    }
    return saletotal;
  }

  getRefundedTotalWithQuantity(basketDetails: { products: string | any[]; }): number {
    let quantity = 0;
    for (let index = 0; index < basketDetails.products.length; index++) {
      const product: any = basketDetails.products[index];

      if (!product.refundedReasonDescription) {

        quantity = quantity + product.quantity;

      } else {
        quantity = quantity + (product.quantity - product.refundedQuantity);

        // basketDetails.total = basketDetails.total + product.refundedTotal;

      }
    }
    return quantity;

  }

  /**
   * Discount Total
   * @returns Discount Total
   */
  updateDiscountTotal() {
    let refundTotal = this.transactionDocument.basketSummary.refundTotal ? this.transactionDocument.basketSummary.refundTotal : 0;
    AppLoggerService.logInfo(this.className, "updateDiscountTotal", `refundTotal: ${refundTotal} this.transactionDocument.basketSummary: ${this.transactionDocument.basketSummary}`);
    const discountTotal =
      Math.abs(
        Math.abs(this.transactionDocument.basketSummary.saleTotal) -
        (
          Math.abs(this.transactionDocument.basketSummary.basketTotal) + Math.abs(refundTotal)
        )
      );
    AppLoggerService.logDebug(this.className, "updateDiscountTotal", "discountTotal", discountTotal)
    return Number(discountTotal.toFixed(2));
  }

  updateReasonCode(reasonCode: {
    code: string;
    name: string;
  }): TransactionDocumentBuilder {
    this.transactionDocument.reasonCode = reasonCode.code;
    this.transactionDocument.reasonDescription = reasonCode.name;
    return this;
  }

  updateManagerOverride(
    useroverride: UserOverride
  ): TransactionDocumentBuilder {
    this.transactionDocument.override = useroverride;
    return this;
  }

  updateUserID(
    userID: string
  ): TransactionDocumentBuilder {
    this.transactionDocument.userId = userID;
    return this;
  }

  updateUserName(name: any) : TransactionDocumentBuilder {
    this.transactionDocument.userName = name;
    return this;

  }
  
  addCustomerDetails(customerDetail: Customer): TransactionDocumentBuilder {
    this.transactionDocument.customer = customerDetail;
    return this;
  }

  updateTaxBreakdown(basketDetails: Basket): TransactionDocumentBuilder {
    // let transactionDiscountTotal = 0;
    let taxBreakdown: TaxBreakdown = {
      taxLines: [],
      totalTaxableAmount: 0,
    };



    // if (this.transactionDocument.basket.transactionDiscount && this.transactionDocument.basket.transactionDiscount.length > 0) {
    //   this.transactionDocument.basket.transactionDiscount.forEach((discount) => {
    //     transactionDiscountTotal += discount.discountAmount;
    //   });
    // }

    // if (this.transactionDocument.basket.transactionPromotion && this.transactionDocument.basket.transactionPromotion.length > 0) {
    //   this.transactionDocument.basket.transactionPromotion.forEach(
    //     (promotion) => {
    //       transactionDiscountTotal += promotion.promotionAmount;
    //     }
    //   );
    // }

    basketDetails.products.forEach((product: any) => {
      let taxLine: TaxLine = {
        itemLineId: product.itemLineId,
        VAT: product.selectedVAT ? product.selectedVAT : 0,
        VATCode: product.selectedVATCode,
        taxLineTotal: 0,
        taxableAmount: product.total,
        PreTax: 0
      };
      AppLoggerService.logInfo(this.className, "updateTaxBreakdown", `item line ID :, ${product.itemLineId},
        "tax line :", ${taxLine}`);

      // step 1
      // if Transaction Discount and/or promotion applied, find net selling price of each product as taxableamount
      // if (transactionDiscountTotal > 0) {
      product = this.basketService.validateProductItemDiscount(product);

      const productContributionInTotal =
        product.itemDiscounts.trnDiscountsPortion +
        product.itemDiscounts.trnPromotionsPortion -
        product.itemDiscounts.refundPortion;
      //  tp+td-rp;

      AppLoggerService.logInfo(this.className, "updateTaxBreakdown", `item line ID , ${product.itemLineId},
        "contribution :", ${productContributionInTotal}`);
      // calculate net selling price after applying transaction discount as per product contribution
      taxLine.taxableAmount -= productContributionInTotal;
      // }

      //step 2 - find pre tax
      taxLine.PreTax = this.numberUtilService.trimTo2Decimal2((taxLine.taxableAmount * 100) / (100 + taxLine.VAT));

      //step 3 - Update taxbreakdown
      taxBreakdown.totalTaxableAmount += taxLine.taxableAmount;
      taxLine.taxableAmount = this.numberUtilService.trimTo2Decimal2(taxLine.taxableAmount);
      
      // step 4 - update tax Line total
      taxLine.taxLineTotal =  this.numberUtilService.trimTo2Decimal2(taxLine.taxableAmount - taxLine.PreTax);
      taxBreakdown.taxLines.push(taxLine);
    });

    taxBreakdown.totalTaxableAmount = this.numberUtilService.trimTo2Decimal2(taxBreakdown.totalTaxableAmount);
    this.transactionDocument.basket.taxBreakdown = taxBreakdown;
    return this;
  }

  updateTotalTaxSummary(): TransactionDocumentBuilder {

    AppLoggerService.logDebug(this.className, "updateTotalTaxSummary", "Total Tax Summery Request :", this.transactionDocument.basket.taxBreakdown);


    let totalTaxSummaryArray: TotalTaxSummary[] = []
    let totalTaxSummaryGroup = []

    AppLoggerService.logDebug(this.className, "updateTotalTaxSummary", "Tax Lines for Total Tax Summery :", this.transactionDocument.basket.taxBreakdown.taxLines);


    this.transactionDocument.basket.taxBreakdown.taxLines.forEach((element: { VATCode: any; VAT: any; PreTax: any; taxLineTotal: any; }) => {
      let TaxSummary: TotalTaxSummary = {
        VATCode: "",
        VAT: -12345,
        PreTaxSum: 0,
        TaxSum: 0,
        TXrateSum: 0
  
      };
       TaxSummary.VATCode = element.VATCode;
        TaxSummary.VAT = element.VAT;        
        TaxSummary.PreTaxSum = this.numberUtilService.trimTo2Decimal2(element.PreTax);
        TaxSummary.TaxSum = this.numberUtilService.trimTo2Decimal2(element.taxLineTotal);
        TaxSummary.TXrateSum = this.numberUtilService.trimTo2Decimal2(TaxSummary.PreTaxSum + TaxSummary.TaxSum);      
        totalTaxSummaryArray.push(TaxSummary);
    })

    AppLoggerService.logDebug(this.className, "updateTotalTaxSummary", "Total Tax Summery  Without Grouped : ", totalTaxSummaryArray);
    
    totalTaxSummaryGroup = totalTaxSummaryArray.reduce((preparedArray:any,currentObj) => {

      let ind = preparedArray.findIndex((x: { VAT: any; }) => x.VAT === currentObj.VAT);
      if(ind === -1){
        preparedArray.push(currentObj)
      }else {
        preparedArray[ind].VATCode = currentObj.VATCode;
        preparedArray[ind].VAT = currentObj.VAT;
        preparedArray[ind].PreTaxSum += currentObj.PreTaxSum;
        preparedArray[ind].TaxSum += currentObj.TaxSum;
        preparedArray[ind].TXrateSum += currentObj.TXrateSum;
      }
      return preparedArray;
    },[])
    
    AppLoggerService.logDebug(this.className, "updateTotalTaxSummary", "Total  Tax Summer Group :",totalTaxSummaryGroup);


    this.transactionDocument.basket.totalTaxSummary = totalTaxSummaryGroup;

    return this;

  }


  /**
   * TransactionId
   * @returns OriginalTransactionId
   */
  addOriginalTransId(tranDoc:TransactionDocument): TransactionDocumentBuilder {
    if (this.transactionDocument.type === TRANSACTION_TYPE.REFUND || this.transactionDocument.type === TRANSACTION_TYPE.SALE_REFUND || this.transactionDocument.type === TRANSACTION_TYPE.SALE_EXCHANGE) {
      this.transactionDocument.originalTransId = tranDoc.transactionId;
      if(tranDoc.apiResponse && tranDoc.apiResponse.internalId)
      {
        this.transactionDocument.originalExternalId = tranDoc.apiResponse.internalId.toString();
      }
    }
    return this;
  }

  /**
   * unreferenced Refund
   * @returns boolean value
   */
  addUnreferencedRefund(): TransactionDocumentBuilder {
    this.transactionDocument.unreferencedRefund = true;
    return this;
  }

  getRefundTotal() {
    let totalRefund = 0;
    for (let index = 0; index < this.transactionDocument.basket.products.length; index++) {
      const product: TProduct = this.transactionDocument.basket.products[index];
      if (product.refundedTotal) {
        totalRefund = totalRefund + product.refundedTotal;
      }
      AppLoggerService.logDebug(this.className, "getRefundTotal", "totalRefund" , totalRefund)
    }
    return totalRefund;
  }

  docId(docId: any): TransactionDocumentBuilder {
      this.transactionDocument.id = docId;
    return this;
  }
}
